import { GetStaticProps } from 'next';
import Head from 'next/head';

import BluebonnetLandingContent from '../../components/_organisms/BluebonnetLandingContent';
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import { DefaultLocale } from '../../providers/tolgee';

interface Props {
  isAuthenticated: boolean;
}

const BluebonnetThankYouLandingPage = ({ isAuthenticated }: Props) => {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <LandingPageLayout
        title="Thank you — The Curipod + Texas Bluebonnet Curriculum"
        subTitle="Bluebonnet brings structure and rigor to K-5 Texas RLA classrooms. Curipod brings the dialogue, the curiosity, and the deep engagement with the Bluebonnet curriculum. A powerful complement to the resources your teachers are already using."
        disableHeadline={true}
      >
        <BluebonnetLandingContent variant="thank-you" isAuthenticated={isAuthenticated} />
      </LandingPageLayout>
    </>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      _tolgeeSSR: {
        language: DefaultLocale,
      },
    },
  };
};

export default BluebonnetThankYouLandingPage;
